import React from 'react';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import * as S from './EmptyCollectionList.styled';
import { useIsTopBannerVisible } from '@/hooks/useIsTopBannerVisible';
import { UniversalPlusIcon } from '@/components/UI/Icons/Icons';

interface EmptyCollectionListProps {
  onCreate: () => void;
}

export const EmptyCollectionList = ({ onCreate }: EmptyCollectionListProps) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const isTopBannerVisible = useIsTopBannerVisible();

  return (
    <S.EmptyCollectionList
      $isTopBannerVisible={isTopBannerVisible}
      data-testid="collections-empty"
    >
      <S.Title>{t('bookmark_collections.add_collection_empty_title')}</S.Title>
      <S.Description>
        {t('bookmark_collections.add_collection_empty_description')}
      </S.Description>
      <S.AddButton
        height={36}
        appearance="primary"
        borderRadius={20}
        onClick={onCreate}
        data-testid="collections-empty-button"
      >
        <UniversalPlusIcon fill={theme.palette.system.white} />
        {t('bookmark_collections.add_collection_empty_button')}
      </S.AddButton>
    </S.EmptyCollectionList>
  );
};
